import { SID_IS_BASE_URL } from 'Modules/shareholders-id/constants';

const controller = [
  'IS_SidRequestRepository',
  'cbpToast',
  '$scope',
  '$stateParams',
  '$state',
  function (SidRequestRepository, cbpToast, $scope, $stateParams, $state) {
    this.$onInit = () => {
      this.sidRequestId = $stateParams.sidRequestId;
      this.loading = false;
      this.fetchSidRequest();
    };

    this.fetchSidRequest = async () => {
      this.loading = true;
      try {
        this.sidRequest = await SidRequestRepository.getById(this.sidRequestId);
      } catch (err) {
        this.error = err;
      } finally {
        this.loading = false;
        $scope.$apply();
      }
    };

    this.approve = async () => {
      try {
        await SidRequestRepository.setApproval(this.sidRequestId, true, null);
        cbpToast.show('The SID request has been approved.', 'success');
        $state.go('shareholders-id.issuer.landing');
      } catch (err) {
        if (err.status === 412) {
          cbpToast.show(
            'The SID request has not been approved, the request is not waiting for approval',
            'negative'
          );
          $state.go('shareholders-id.issuer.landing');
        }
      }
    };

    this.reject = async (reason) => {
      try {
        await SidRequestRepository.setApproval(
          this.sidRequestId,
          false,
          reason
        );
        cbpToast.show('The SID request has been rejected.', 'success');
        $state.go('shareholders-id.issuer.landing');
      } catch (err) {
        if (err.status === 412) {
          cbpToast.show(
            'The SID request has not been rejected, the request is not waiting for approval',
            'negative'
          );
          $state.go('shareholders-id.issuer.landing');
        }
      }
    };

    this.handleEditClicked = async () => {
      $state.go('shareholders-id.issuer.sidRequestDetails.edit', {
        sidRequestId: this.sidRequestId,
      });
    };

    this.handleDeleteClicked = async () => {
      await SidRequestRepository.deleteById(this.sidRequestId);
      cbpToast.show('The SID request has been deleted.', 'success');
      $state.go('shareholders-id.issuer.landing');
    };
  },
];

export default {
  controller,
  templateUrl: `${SID_IS_BASE_URL}/views/sid-request-details/overview/sid-request-details-overview.template.html`,
};
